u.CarouselMove = class extends u.CarouselNav {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();
        this.toIndex = this.getAttribute('u-to');

        this._click = () => {
            this.$forElement.$moveTo(this.toIndex);
        };

    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('click', this._click);

    }
    
    detachedCallback() {
        /**
         *
         */
        this.removeEventListener('click', this._click);        
    }    
};

u.CarouselMove.register('u-carousel-move');